/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { type ReactNode } from "react";
import { useHealthieWebUrl } from "../lib/envConfig";

/**
 * A link to a client or provider record in the Healthie web app for this environment. Renders an
 * inert span until the environment's Healthie host is known — a link to the wrong environment is
 * worse than a moment without one.
 */
export function HealthieLink({
  healthieId,
  className,
  children,
  ariaLabel,
}: {
  healthieId: string;
  className?: string;
  children: ReactNode;
  ariaLabel?: string;
}) {
  const base = useHealthieWebUrl();
  if (base === null) {
    return <span className={className}>{children}</span>;
  }
  return (
    <a
      href={`${base}/users/${healthieId}`}
      target="_blank"
      rel="noreferrer"
      className={className}
      aria-label={ariaLabel}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
}
